<template>
  <div class="team">

    <v-container class="my-2">
      <v-layout>
          <v-flex>
              <div class="headlain">v-sendaiの運営スタッフです</div>
          </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm6 md4 lg3 v-for="person in team" :key="person.name">
          <v-card flat class="text-xs-center ma-3" color="blue lighten-4">
            <v-responsive class="pt-4">
              <v-avatar size="100" color="white">
                <img :src="person.avatar">
              </v-avatar>
            </v-responsive>
            <v-card-text>
              <div class="subheading">{{ person.name }}</div>
              <div class="blue-grey--text">{{ person.role }}</div>
            </v-card-text>
            <v-card-actions>
                <div class="ml-1 blue-grey--text title">{{ person.twitter }}</div>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

    </v-container>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      team: [
        { name: 'Kさん', role: 'いろいろまとめてる', avatar: 'animal_arupaka.png', twitter:'@arupaka'},
        { name: 'Dさん', role: '実際にvue使ってる', avatar: 'animal_neko.png', twitter:'@neko'},
        { name: 'Mさん', role: 'デザイン得意', avatar: 'animal_hamster.png', twitter:'@hamster'},
        { name: 'Sさん', role: 'フロント好き', avatar: 'animal_hiyoko.png', twitter:'@hiyoko'},
        { name: 'Tさん', role: 'vueに興味がある人', avatar: 'animal_inu.png', twitter:'@inu'},
        { name: 'Yさん', role: 'よく動く', avatar: 'animal_usagi.png', twitter:'@usagi'}
      ]
    }
  }
}
</script>